import { IProactiveRxRuleFormData } from '@common/models';
import { ProactivePrescriptionRuleSalesItemRow } from '@common/views/proactivePrescriptions';

import { observer } from 'mobx-react';
import React from 'react';
import { Table } from 'react-bootstrap';

interface ProactivePrescriptionRuleDetailsTableProps {
  dataSource: IProactiveRxRuleFormData[];
  listName: string;
  isHospital?: boolean;
  isDisabled?: boolean;
}

export const ProactivePrescriptionRuleDetailsTable = observer(
  ({
    dataSource,
    listName,
    isHospital = false,
    isDisabled = false,
  }: ProactivePrescriptionRuleDetailsTableProps) => {
    const preferredW = 200;
    const actionW = 200;

    // Width cols based on isHospital flag
    const widthCols = `calc((100% - ${isHospital ? preferredW + actionW : actionW}px) / 2)`;

    return (
      <Table className="proactive-prescription-rule-details-table" hover>
        <colgroup>
          <col style={{ width: widthCols }} />
          <col style={{ width: widthCols }} />
          {isHospital && <col style={{ width: preferredW }} />}
          <col style={{ width: actionW }} />
        </colgroup>
        <thead>
          <tr>
            <th>DESCRIPTION</th>
            <th>OPTION</th>
            {isHospital && <th className="preferred-col">SUGGESTED MEDICATION</th>}
            <th className="action-col">ACTION</th>
          </tr>
        </thead>
        <tbody>
          {dataSource.map((item, hospIdx) => (
            <ProactivePrescriptionRuleSalesItemRow
              key={`${listName}_${hospIdx}`}
              salesItemName={item.salesItemName}
              salesItemOptions={item.salesItemOptions}
              index={hospIdx}
              listName={listName}
              isHospital={isHospital}
              isDisabled={isDisabled}
            />
          ))}
        </tbody>
      </Table>
    );
  },
);
